import type {
    SelectCommerceCheckoutShippingMethodRequest,
    SelectCommerceCheckoutShippingMethodResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";
export const selectCommerceCheckoutShippingMethodOperation = defineCommerceOperation<
    SelectCommerceCheckoutShippingMethodRequest,
    SelectCommerceCheckoutShippingMethodResponse
>("commerce.checkout.select-shipping");
